import DropdownClosedQuestion from 'models/common/form/question/DropdownClosedQuestion';

import ClosedQuestionService from 'services/common/form/question/ClosedQuestionService';

export default class DropdownClosedQuestionService extends ClosedQuestionService {
	toModel(question) {
		return new DropdownClosedQuestion(super.toModel(question));
	}
}
